import React from 'react';

import './Input.scss';

type InputComponentProps = {
  id: string;
  value: string | number;
  type?: string;
  disabled?: boolean;
  prefix?: JSX.Element;
  width?: string | number;
  errorText?: string;
  textArea?: boolean;
  onChange?: (event: React.ChangeEvent<HTMLInputElement>) => void;
  onTextAreaChange?: (event: React.ChangeEvent<HTMLTextAreaElement>) => void;
};

function Input({
  id,
  type = 'text',
  value,
  disabled,
  prefix,
  width,
  errorText,
  textArea,
  onChange,
  onTextAreaChange,
}: InputComponentProps) {
  return (
    <div className={`input ${errorText ? 'error' : ''}`}>
      {prefix && <span className={'prefix'}>{prefix}</span>}
      {!textArea && (
        <input
          id={id}
          type={type}
          value={value}
          onChange={(event) => onChange(event)}
          disabled={disabled}
          width={width}
        ></input>
      )}
      {textArea && (
        <textarea
          id={id}
          value={value}
          onChange={(event) => onTextAreaChange(event)}
          cols={27}
          rows={8}
        ></textarea>
      )}
      {errorText && <div>{errorText}</div>}
    </div>
  );
}

export default Input;
